import type { PremiereSequenceReference } from '@mimir/primitive/premiere/premiereReference';

/**
 * Implements the same sequence key generation as premiere.jsx, so that sequence
 * references in from the CEP bridge can be used in the older premiere.jsx code.
 */
export function sequenceRefToKey(seqRef: PremiereSequenceReference) {
  return seqRef.sequenceId + '|' + seqRef.projectPath.replace(/\\/g, '/');
}


